"use client";

import React from "react";
import { Facebook, Instagram, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-none" />)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors duration-200 text-sm font-medium tracking-normal">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function StopkaDworu() {
  return <section data-section-id="125816" id="footer" className="dark bg-secondary text-foreground pt-20 pb-10 border-t border-border !border-0 border-solid border-[rgb(48,53,65)]">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 mb-16">
          
          {}
          <div className="md:col-span-5 lg:col-span-4 flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <img src="https://bhmarketing.pl/wp-content/uploads/2026/06/1.png" alt="BH Marketing" className="object-contain !w-[300px] !h-[90px]" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-sm font-sans">BH Marketing to boutique'owa agencja strategii i marketingu. Pracujemy z markami, które mają wysokie standardy - i pomagamy im komunikować to w sposób, który przyciąga właściwych klientów.</p>
          </div>

          {}
          <div className="md:col-span-3 lg:col-span-4 lg:justify-self-center">
            <h3 className="font-sans font-bold text-xl mb-6 text-foreground tracking-tighter uppercase">Nawigacja</h3>
            <MenuProvider menu_id="47">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-4 lg:col-span-4 lg:justify-self-end">
            <h3 className="font-sans font-bold text-xl mb-6 text-foreground tracking-tighter uppercase">Kontakt</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-muted-foreground group">
                <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5 transition-transform group-hover:scale-110" />
                <span className="text-sm leading-relaxed font-sans">ul. Fabryczna 6, 53-609 Wrocław, Polska</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground group">
                <Phone className="w-5 h-5 text-primary shrink-0 transition-transform group-hover:scale-110" />
                <Link to="tel:+48500848890" className="text-sm hover:text-primary transition-colors font-sans">
                  +48 500 848 890
                </Link>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground group">
                <Mail className="w-5 h-5 text-primary shrink-0 transition-transform group-hover:scale-110" />
                <Link to="mailto:kontakt@bhtechnologies.pl" className="text-sm hover:text-primary transition-colors font-sans">
                  kontakt@bhtechnologies.pl
                </Link>
              </li>
            </ul>
          </div>

        </div>

        <Separator className="bg-primary/20 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-xs text-muted-foreground tracking-widest uppercase font-sans text-center md:text-left">© 2026 AGENDOO spółka z ograniczoną odpowiedzialnością | Wszelkie prawa zastrzeżone</p>
          
          <div className="flex items-center gap-4">
            <Link to="https://www.instagram.com/bhmarketing.pl/" aria-label="Instagram" className="flex items-center justify-center w-10 h-10 rounded-full border border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-200">
              <Instagram className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}